import {defineComponent, type PropType, ref, watch} from 'vue';
import {type ActorAuditLogDto} from "@/api/enterprise-gateway-api.proxy.ts";
import {useFormatting} from "@/composables/currency-format.ts";

export default defineComponent({
    name: 'AegAdminAuditActor',
    props: {
        auditLogs: {
            type: Array as PropType<ActorAuditLogDto[]>,
            required: true,
            default: () => []
        },
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    setup: function (props) {
        const {formatDateTime} = useFormatting();
        const logs = ref<ActorAuditLogDto[]>([]);
        const loading = ref<boolean>(false);
        const emptyState = ref<boolean>(false);

        const formatChanges = (changes: { [key: string]: any } | undefined): string => {
            if (!changes) return '';
            return JSON.stringify(changes)
        };

        const auditLogsChanged = (newLogs: ActorAuditLogDto[]) => {
            if (!newLogs) return;
            logs.value = newLogs;
            emptyState.value = newLogs.length === 0;
        };

        watch(() => props.auditLogs, auditLogsChanged, {immediate: true, deep: true});
        watch(() => props.isLoading, (newValue) => { loading.value = newValue }, {immediate: true, deep: true});

        return {
            loading,
            emptyState,
            logs,
            formatDateTime,
            formatChanges
        };
    }
})

